import { YupSchema } from 'services/yup/types'
import { yupArray, yupIgnore, yupNumber, yupObject } from 'services/yup'
import {
  OptionedPackage,
  OptionedPreset,
  OptionGroupPreset,
} from 'services/api/entities/catalog/packages/common'
import { productWithUpsellingPresetVS } from './productWithUpsellingPackage'
import { packageBaseVS } from './packageBase'

const optionGroupPresetVS: YupSchema<OptionGroupPreset> = yupObject().shape({
  id: yupNumber().required(),
  items: yupArray(yupNumber().required()),
})

export const optionedPresetVS: YupSchema<OptionedPreset> =
  productWithUpsellingPresetVS.shape({
    quantityMultiplier: yupNumber().min(1).max(100),
    options: yupArray(optionGroupPresetVS),
    optionsFull: yupArray(),
  })

export const optionedPackageVS: YupSchema<OptionedPackage> =
  packageBaseVS.shape({
    products: yupArray(optionedPresetVS).min(1),
    isBundledPackage: yupIgnore(),
  })
